import React, { useState } from 'react';
import { CalendarOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Row, Select } from 'antd';

import { DATE_FORMAT_DISPLAY, DATE_ONLY_FORMAT_VALUE } from '../../../constants';
import { FieldTypes } from '../../../constants/formConfig';

const DatepickerMultiple = ({ value, onChange, dateFormat, placeholder, disabled, disabledSelect }) => {
    const [ open, setOpen ] = useState(false);

    const handleDateChange = e => {
        const dateStr = e.format(DATE_ONLY_FORMAT_VALUE);
        const oldValues = (value || []);
        if (!oldValues.includes(dateStr)) {
            onChange([ ...(value || []), dateStr ]);
        }
    };

    return (
        <Row gutter={8} wrap={false}>
            <Col flex="auto">
                <Select
                    placeholder={placeholder}
                    mode="multiple"
                    value={value}
                    onChange={onChange}
                    open={false}
                    disabled={disabledSelect}
                    showArrow={false}
                    style={{ width: '100%' }}
                />
            </Col>
            <Col flex="none">
                <DatePicker
                    format={dateFormat}
                    onChange={handleDateChange}
                    value=""
                    open={open}
                    onOpenChange={(open) => setOpen(open)}
                    style={{ visibility: "hidden", width: 0, padding: 0 }}
                />
                <Button disabled={disabled} type="text" onClick={() => setOpen(prev => !prev)}>
                    <CalendarOutlined style={{ fontSize: '16px' }} />
                </Button>
            </Col>
        </Row>
    );
};

const DatepickerMultipleField = ({
    label,
    loading,
    fieldName,
    disabled,
    disabledSelect,
    onSelect,
    onChange,
    format,
    rules,
    placeholder,
}) => {
    const dateFormat = format || DATE_FORMAT_DISPLAY;

    const getRules = () => rules || [];

    const getPlaceHolder = () => placeholder || `${label || 'date'}`;

    return (
        <Form.Item
            label={label}
            name={fieldName}
            rules={getRules()}
            shouldUpdate={false}
        >
            <DatepickerMultiple
                disabled={disabled}
                disabledSelect={disabledSelect}
                placeholder={getPlaceHolder()}
                dateFormat={dateFormat}
                onChange={onChange}
            />
        </Form.Item>
    );
};

DatepickerMultipleField.fieldType = FieldTypes.SELECT;

export default DatepickerMultipleField;
